import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import {typesReguserdet} from '../svtypes/reguserdet'


const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadReguserdetBegin = () => dispatch => {
    dispatch({
        type:'GET_REGUSERDET_BEGIN'
        
    })
}


export const geLoadReguserdetSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_REGUSERDET_SUCCESS',
        payload: data
    })
}

export const getLoadReguserdetError = (e) =>dispatch => {
    dispatch({
        type:'GET_REGUSERDET_ERROR',
        error:e
    })
}





export function loadReguserDet(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadReguserdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/reguserDetail`
        const body = {
            "id": (nameQParam? nameQParam:3)
           }
          
        
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if( r.data && (r.data['email']  )){
                    let ob = r.data
                    ob['id'] = ob['customerId']
                   
                    const comData = { my_data_reguserdet:  ob }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_addresslist.push(sod)
                    });

                   */
                    dispatch(geLoadReguserdetSuccess(comData))
                }
                else {
                    const comData = { my_data_reguserdet:  {
                        "id": -1,
                        "fname": "John",
                        "lname": "Glen",
                        "email": "john123@yahoo.com",
                        "username": "pet123@yahoo.com",
                        "password": "pet123",
                        "passwordmirror": "pet123",
                        "isdcode": "+1",
                        
                        "encpassword": "pet123@yahoo.com",
                        "phone": "5121234356"
                    }}
                    dispatch(getLoadReguserdetError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReguserdetError(e))
        )
    }
}


export function addReguserNow(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyReguserNow from Microservices DB swith sae key :' + rqValues)
    console.log(rqValues)
    if(rqValues && rqValues.addressNew &&  (rqValues.addressNew.username.length > 0)){
        rqValues.addressNew.login =  rqValues.addressNew.username
    }else if(rqValues && rqValues.addressNew &&  (rqValues.addressNew.email.length > 0)){
        rqValues.addressNew.login =  rqValues.addressNew.email
    }
    return dispatch => {
        dispatch(svcreateOrModifyReguserBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createOrModifyReguserNow`
        //this will create only 
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_reguser_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_reguser_confirmation = r.data
                    

                   
                    dispatch(getCreateOrModifyReguserSuccess(comData))
                }
                else {
                    comData.my_data_reguser_confirmation.status = "FAILED"
                    comData.my_data_reguser_confirmation.reguserId = "XXX"
                    comData.my_data_reguser_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyReguserSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyReguserError(e))
        )
    }

}


export const svcreateOrModifyReguserBegin = () => dispatch => {
    dispatch({
        type:typesReguserdet.GET_SAVEREGUSER_BEGIN
        
    })
}


export const getCreateOrModifyReguserError = (e) =>dispatch => {
    dispatch({
        type:typesReguserdet.GET_SAVEREGUSER_ERROR,
        error:e
    })
}


export const getCreateOrModifyReguserSuccess = (data) => dispatch => {
    dispatch({
        type: typesReguserdet.GET_SAVEREGUSER_SUCCESS,
        payload: data
    })
}


/*svfeb19 start*/

export const geLoadRegusergeoSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_REGUSERGEO_SUCCESS',
        payload: data
    })
}

export function loadGeo(){

    console.log('%%%%%%%%%%%%%%%sv++++REST API  loadGeo FEB19For _doc swith sae key :' )
    return dispatch => {
        dispatch(svLoadReguserdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
        
        axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
        .then(
            r5 => {
                let my_data_geo = null
                if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                    my_data_geo = r5.data
                   
                    const comData = { my_data_geo:  my_data_geo }

                    //we are lowercase aleadt

                    
                    dispatch(geLoadRegusergeoSuccess(comData))
                }
                else {
                    const comData = { my_data_geo: null }
                    dispatch(getLoadReguserdetError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReguserdetError(e))
        )
    }
}